<template>
  <fragment>
    <ul id="slide-out" class="sidenav sidenav-fixed">
      <div class="dashboard_banner">
        <img src="http://clovermandalay.org/storage/logo/BokXpNUyrCeDs2jM82R7U6gg30D0zVYUrbLlilaB.png" class="responsive-img" />
        <h6 class="white-text darken-2">Online Learning System</h6>
        <h6 class="white-text darken-2">Admin</h6>
        <img class="responsive-img" />
      </div>
      <li>
        <router-link to="/home">
          <i class="material-icons">home</i>Home
        </router-link>
      </li>
        <li>
        <router-link to="/class">
          <i class="material-icons">class</i>Class
        </router-link>
      </li>
      <li>
        <router-link to="/student">
          <i class="material-icons">person</i>Student
        </router-link>
      </li>
        <li>
        <router-link to="/course">
          <i class="material-icons">subject</i>Course
        </router-link>
      </li>
    </ul>

    <ul id="slide-out" class="sidenav">
      <div class="dashboard_banner">
        <img src="http://clovermandalay.org/storage/logo/BokXpNUyrCeDs2jM82R7U6gg30D0zVYUrbLlilaB.png" class="responsive-img" />
        <h6 class="white-text darken-2">Online Learning System</h6>
        <h6 class="white-text darken-2">Admin</h6>
        <img class="responsive-img" />
      </div>
      <li>
        <a>
          <i class="material-icons">home</i>Home
        </a>
      </li>
    </ul>
  </fragment>
</template>
<script>
export default {};
</script>
<style lang="scss" >
@import url("https://fonts.googleapis.com/css?family=Quicksand&display=swap");

@import "@/style/colors.scss";

.sidenav {
  width: 15%;
}

.sidenav li a {
  font-family: "Quicksand", sans-serif;
  color: black;
}

.dashboard_banner {
  text-align: center;
  padding: 5px;
  padding-top: 10px;
  background-color: $primaryColor;
}

.dashboard_banner h6 {
  font-family: "Quicksand", sans-serif;
  text-shadow: 2px 2px 2px black;
}

.dashboard_banner img {
  width: 25%;
  margin: 0px !important;
  padding: 0px !important;
}

#slide-out {
  margin: 0px !important;
}
</style>